import React from 'react';
import BodyText from '../../../ui/Typography/texts/BodyText';
import HeadingSmall from '../../../ui/Typography/titles/HeadingSmall';
import styles from './EnergyEfficiencyLabels.module.scss';
import EnergyRangeLuminar from './EnergyRangeLuminar';
import EuropeFlag from './EuropeFlag';
import LampSymbol from './LampSymbol';
const EnergyEfficiencyLabels = ({ compatible, energyImageNumber, articleId, hmName, hmLongName, }) => {
    return (React.createElement("div", { className: styles.card },
        React.createElement("header", { className: styles.header },
            React.createElement(HeadingSmall, { Tag: "h2", className: styles.headline },
                React.createElement("span", null, hmName),
                React.createElement("span", null, hmLongName)),
            React.createElement(BodyText, { Tag: "span" }, articleId)),
        React.createElement("div", { className: styles.compatibleStatement },
            React.createElement("span", { className: styles.image },
                React.createElement(LampSymbol, null)),
            React.createElement(BodyText, { Tag: "span" }, compatible)),
        React.createElement("div", { className: styles.EnergyRangeLuminar },
            React.createElement(EnergyRangeLuminar, null)),
        React.createElement("div", { className: styles.dateNote },
            React.createElement(BodyText, { Tag: "span" }, energyImageNumber),
            React.createElement(EuropeFlag, null))));
};
export default EnergyEfficiencyLabels;
//# sourceMappingURL=EnergyEfficiencyLabels.js.map